/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicMyHomeV1UpdateUserStatusRequest,
  TPublicMyHomeV1UpdateUserStatusModel,
  IMappers,
  TPublicMyHomeV1UpdateUserStatusResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IUpdateMyHomeStatusResponse } from '../../../entities/user_status/UpdateMyHomeStatusResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicMyHomeV1UpdateUserStatusModel(
  parameters: TPublicMyHomeV1UpdateUserStatusRequest,
): TPublicMyHomeV1UpdateUserStatusModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/my-home/v1/update-user-status/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicMyHomeV1UpdateUserStatusOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicMyHomeV1UpdateUserStatusRequest;
}

export async function fetchPublicMyHomeV1UpdateUserStatus<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeV1UpdateUserStatusOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicMyHomeV1UpdateUserStatusResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicMyHomeV1UpdateUserStatusModel(parameters),
    config,
  )) as FetchResponse<TPublicMyHomeV1UpdateUserStatusResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUpdateMyHomeStatusResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicMyHomeV1UpdateUserStatusResponse>;
}
